import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectWindowWidth = createSelector(
  (state: RootState) => state.layout.windowWidth,
  (windowWidth: number) => windowWidth
)

export default selectWindowWidth
